import { Icon, Loader, Menu } from "semantic-ui-react";

import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import useWindowSize from "react-use/lib/useWindowSize";

import Button from "../Buttons/Button";
import Label from "../Label/Label";

function MenuItem({ label, labelColor = "blue", children, active, loading, onClick, ...props }) {
	return (
		<Menu.Item as={!onClick && Link} active={!!active} onClick={onClick} {...props}>
			{!loading && label !== undefined && (
				<Label size="tiny" color={labelColor}>
					{label}
				</Label>
			)}

			{children}

			{loading && <Loader as={Icon} inline active size="tiny" style={{ float: "right" }} />}
		</Menu.Item>
	);
}

export function getActive({ path, active, currentPath, options }) {
	return active !== undefined
		? active
		: currentPath.endsWith(`${path}`) ||
				currentPath.includes(`/${path}/`) ||
				options?.find(({ path }) => currentPath.includes(path));
}

export default function VerticalMenu({ options, ...props }) {
	const { t } = useTranslation();
	const { width } = useWindowSize();
	const { hash, pathname } = useLocation();

	const [open, setOpen] = useState(false);

	const large = width > 600;

	const currentPath = pathname + hash;

	useEffect(() => {
		setOpen(false);
	}, [currentPath]);

	return (
		<>
			{!large && (
				<Button fluid secondary={false} active={open} onClick={() => setOpen((open) => !open)}>
					{open ? t("hideMenu", "Hide menu") : t("showMenu", "Show menu")}
				</Button>
			)}

			{(large || open) && (
				<Menu fluid vertical text style={{ margin: 0 }} {...props}>
					{options
						.filter(({ hidden }) => !hidden)
						.map(
							({ to, name, text, path, label, labelColor, options, active, loading, onClick }, index) => {
								path = path || to;
								active = getActive({ path, active, currentPath, options });

								return (
									<Fragment key={index}>
										<MenuItem
											to={path}
											label={label}
											labelColor={labelColor}
											active={active}
											loading={loading}
											onClick={onClick}
										>
											{name || text}
										</MenuItem>

										{options && active && (
											<VerticalMenu
												options={options}
												style={{
													paddingLeft: 15,
													borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
												}}
											/>
										)}
									</Fragment>
								);
							},
						)}
				</Menu>
			)}
		</>
	);
}
